/**
 * methods for checking if query data exists
 */
export default {
    data() {
        return {
            checkClimateDataFields: {
                precipitation: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'p10',
                        'p25',
                        'p50',
                        'p75',
                        'p90',
                    ],
                },
                snow_on_ground_depth: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'p10',
                        'p25',
                        'a',
                        'p75',
                        'p90',
                    ],
                },
                snow_water_equivalent: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'p10',
                        'p25',
                        'a',
                        'p75',
                        'p90',
                    ],
                },
                manual_snow_survey: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'p10',
                        'p25',
                        'p50',
                        'p75',
                        'p90',
                    ],
                },
                temperature: {
                    current: [
                        'min',
                        'max',
                    ],
                    historical: [
                        'maxavg',
                        'maxp90',
                        'minavg',
                        'minp10',
                    ],
                },
            },
            checkGroundLevelDataFields: {
                hydrograph: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'a',
                        'max',
                        'min',
                        'p25',
                        'p75',
                    ],
                },
            },
            checkStreamflowDataFields: {
                monthly_mean_flow: {
                    current: [
                        'avg',
                        'm',
                        'max',
                        'min',
                    ],
                    yearly: [
                        'days',
                        'full_month',
                        'm',
                        'qa',
                        'v',
                        'year',
                    ],
                },
                seven_day_flow: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'max',
                        'min',
                        'p25',
                        'p50',
                        'p75',
                    ],
                },
                stage: {
                    current: [
                        'v',
                    ],
                    historical: [
                        'max',
                        'min',
                        'p25',
                        'a',
                        'p75',
                    ],
                },
            },
        };
    },
    methods: {
        /**
         * check a single dataset for any non-null values
         * @param  {Array}  dataSet array of data point objects
         * @param  {Array}  fields  array of field names to check
         * @return {Boolean}        true if any field has a non-null value
         */
        checkSingleDataset(dataSet, fields) {
            const hasData = dataSet.some((row) => {
                const rowHasData = fields.some(field => row[field] !== null);
                return rowHasData;
            });
            return hasData;
        },
        /**
         * check one type of data for current and/or historical data
         * @param  {Object} data       data object
         * @param  {String} datasetKey key within the data object
         * @param  {Object} dataField  object with historical & current field names
         * @return {Boolean}        true if any field has a non-null value
         */
        checkChartData(data, datasetKey, dataField) {
            const queryData = data && data[datasetKey];
            // if the data is null or the key doesn't exist
            if (!queryData) {
                return false;
            }

            const hasData = ['historical', 'current'].some((type) => {
                const dataset = queryData[type];
                const fields = dataField[type];
                if (dataset === undefined) {
                    return false;
                }

                return this.checkSingleDataset(dataset, fields);
            });
            return hasData;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/checkQueryData.js